export default __webpack_public_path__ + "static/media/keto_foods@2x.7ada5e72.jpg";